module.exports = __webpack_public_path__ + "img/person-2.6d47b806.png";